(function () {
    if (window.__cartVariantAvailabilityInitialized) {
        return;
    }
    window.__cartVariantAvailabilityInitialized = true;

    // Track processing state to prevent duplicate submissions
    let isProcessing = false;

    async function sendVariantAvailabilityUpdate() {
        try {
            // Fetch current cart data
            const cartResponse = await fetch('/cart.json');
            const cartData = await cartResponse.json();

            // Extract variant SKUs from cart items
            const variantSkus = cartData.items
                .map(item => item.sku)
                .filter(sku => sku);

            if (variantSkus.length > 0) {
                console.log('[Cart] Sending variant availability update with SKUs:', variantSkus);

                // Make the PATCH API call with keepalive flag to ensure it's sent even after navigation
                fetch('/apps/leone/products/variant-availabilities', {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        variant_skus: variantSkus
                    }),
                    keepalive: true // Ensures request completes even if page navigates away
                })
                    .then(response => {
                        console.log('[Cart] Variant availability update sent successfully, status:', response.status);
                    })
                    .catch(error => {
                        console.error('[Cart] Error sending variant availability update:', error);
                    });
            } else {
                console.log('[Cart] No SKUs found in cart, skipping availability update');
            }
        } catch (error) {
            console.error('[Cart] Error processing cart:', error);
        }
    }

    function handleCheckoutClick(event) {
        // Prevent multiple calls
        if (isProcessing) {
            console.log('[Cart] Already processing, skipping');
            return;
        }
        isProcessing = true;

        console.log('[Cart] Checkout button clicked, sending variant availability update');

        // Send the API call
        sendVariantAvailabilityUpdate();

        // Reset after a short delay to allow for navigation
        setTimeout(() => {
            isProcessing = false;
        }, 500);
    }

    function initialize() {
        // 1. Attach to main cart page checkout button (if it exists)
        const mainCartForm = document.querySelector('form.cart-form');
        if (mainCartForm) {
            const checkoutButton = mainCartForm.querySelector('button[name="checkout"]');
            if (checkoutButton) {
                checkoutButton.addEventListener('click', handleCheckoutClick);
                console.log('[Cart] Attached listener to main cart checkout button');
            }
        }

        // 2. Listen for variant:add event (fired when item is added to cart in quick-buy drawer)
        document.addEventListener('variant:add', function (event) {
            console.log('[Cart] variant:add event fired, waiting for drawer content');

            // The variant-added content is loaded shortly after this event
            setTimeout(() => {
                const quickBuyForm = document.querySelector('.ln-quick-buy-drawer__buttons');
                if (quickBuyForm) {
                    const checkoutButton = quickBuyForm.querySelector('button[name="checkout"]');
                    if (checkoutButton && !checkoutButton.hasAttribute('data-cart-listener')) {
                        // Mark button to avoid duplicate listeners
                        checkoutButton.setAttribute('data-cart-listener', 'true');
                        checkoutButton.addEventListener('click', handleCheckoutClick);
                        console.log('[Cart] Attached listener to quick-buy drawer checkout button');
                    }
                }
            }, 100);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        initialize();
    }
})();
